import { SnackbarSonner } from '@tecsinapse/cortex-react'

export const snackbar = new SnackbarSonner({ position: 'bottom-left' })
